import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Progress Component
 * Based on shadcn/ui Progress with DckSlap dark red theme
 * For VIP level progress bars
 */

const Progress = React.forwardRef(({ className, value = 0, max = 100, ...props }, ref) => {
    const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

    return (
        <div
            ref={ref}
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={max}
            aria-valuenow={value}
            className={cn(
                "relative h-2 w-full overflow-hidden rounded-full bg-secondary",
                className
            )}
            {...props}
        >
            <div
                className="h-full bg-primary transition-all duration-300 ease-out"
                style={{ width: `${percentage}%` }}
            />
        </div>
    );
});
Progress.displayName = "Progress";

export { Progress };
